import React from 'react';
import Icon from '@pushpay/icon';

const StaqLogoIcon = props => /*#__PURE__*/React.createElement(Icon, Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.226 14.427a2.5 2.5 0 010-3.522L15.349.733a2.471 2.471 0 013.514 0zm1.239 1.24l7.308-7.326a2.471 2.471 0 013.511 0l-7.306 7.325a2.471 2.471 0 01-3.513 0zm-1.587 7.607L18.524 9.589a2.5 2.5 0 010 3.523L8.4 23.274a2.5 2.5 0 01-3.522 0z"
}));

export default StaqLogoIcon;